import React, { useRef, useEffect, useState } from "react";
import { Button } from "./ui/button";
import { Eraser } from "lucide-react";

export const SignaturePad = ({ onChange, height = 180 }) => {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * ratio;
    canvas.height = height * ratio;
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#0f172a";
  }, [height]);

  const pos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return { x: p.clientX - rect.left, y: p.clientY - rect.top };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = canvasRef.current.getContext("2d"); const { x, y } = pos(e); ctx.beginPath(); ctx.moveTo(x, y); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = canvasRef.current.getContext("2d"); const { x, y } = pos(e); ctx.lineTo(x, y); ctx.stroke(); setEmpty(false); };
  const end = () => { if (!drawing.current) return; drawing.current = false; if (onChange) onChange(empty ? null : canvasRef.current.toDataURL("image/png")); };
  const clear = () => { const c = canvasRef.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); if (onChange) onChange(null); };

  return (
    <div className="space-y-2">
      <div className="rounded-xl border-2 border-dashed border-slate-300 bg-slate-50 relative" style={{ touchAction: "none" }}>
        <canvas
          ref={canvasRef}
          data-testid="signature-canvas"
          style={{ width: "100%", height, display: "block", cursor: "crosshair" }}
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end}
        />
        {empty && <span className="absolute inset-0 grid place-items-center text-sm text-muted-foreground pointer-events-none">Firma qui con il dito o il mouse</span>}
      </div>
      <div className="flex justify-end">
        <Button type="button" variant="outline" size="sm" onClick={clear} data-testid="signature-clear"><Eraser size={14} className="mr-1" /> Cancella</Button>
      </div>
    </div>
  );
};

export default SignaturePad;
